import { capitalize } from "lodash/fp";

import { Stack, Typography } from "@mui/material";

import { getInitials } from "@app/common/utils";
import {
  EnterpriseWorkspaceInvite,
  EnterpriseWorkspaceUser,
} from "@app/common/workspaces/types";

import Avatar from "@rui/Avatar";

const UserRow = ({
  isCurrentUser,
  user,
}: {
  isCurrentUser: boolean;
  user: EnterpriseWorkspaceUser;
}) => (
  <Stack direction="row" alignItems="center">
    <Avatar name={user.fullName} sx={{ mr: 1 }}>
      {user.initials}
    </Avatar>
    <Typography
      variant="bodySecondaryReg"
      sx={{ color: "shades.neutral.600", overflowWrap: "anywhere" }}
    >
      {user.fullName} {isCurrentUser ? " (you)" : ""}
    </Typography>
  </Stack>
);

const InviteRow = ({ invite }: { invite: EnterpriseWorkspaceInvite }) => (
  <Stack direction="row" alignItems="center">
    <Avatar sx={{ mr: 1, bgcolor: "shades.neutral.200" }}>
      {getInitials(invite.email)}
    </Avatar>
    <Typography
      variant="bodySecondaryReg"
      sx={{ color: "shades.neutral.600", overflowWrap: "anywhere" }}
    >
      {invite.email} ({capitalize(invite.status)})
    </Typography>
  </Stack>
);

const WorkspaceSidePanelRow = ({
  userOrInvite,
  isCurrentUser = false,
}: {
  userOrInvite: EnterpriseWorkspaceUser | EnterpriseWorkspaceInvite;
  isCurrentUser?: boolean;
}) => {
  if (userOrInvite.type === "invite") {
    return <InviteRow invite={userOrInvite} />;
  }

  return <UserRow isCurrentUser={isCurrentUser} user={userOrInvite} />;
};

export default WorkspaceSidePanelRow;
